// extracted by mini-css-extract-plugin
module.exports = {"metaverseTypes":"MetaverseTypes_metaverseTypes__3_gCZ","metaverselogos":"MetaverseTypes_metaverselogos__2QqZe"};